import(/* webpackMode: "eager" */ "/home/runner/work/tipsy-ui/tipsy-ui/app/[lang]/@mobile/(app)/create/page.tsx");
